import React from "react";
import { useNavigate } from "react-router-dom";
import { DistributorsTableHeader } from "./distributors-table-header";
import { DistributorsTableRow } from "./distributors-table-row";
import { PendingDistributorRow } from "./pending-distributor-row/pending-distributor-row";
import { mockDistributorsData } from "./mock.data";
import styles from "./distributors-table.module.scss";
import { useTableSort } from "../../../hooks/use-table-sort.hook";
import { ROUTE_PATHS } from "../../../constants/app.constants";

const headerColumns = [
  { label: "Distributor Name", field: "companyName", sortable: true },
  { label: "Location", field: "country", sortable: false },
  { label: "Contact Email", field: "contactEmail", sortable: false },
  { label: "Signed up", field: "createdDate", sortable: false },
  { label: "Last Seen", field: "lastActivity", sortable: false },
  { label: "Members", field: "contacts", sortable: false },
  { label: "Clients", field: "deals", sortable: false },
  { label: "Prospects", field: "revenue", sortable: false },
];

// Transform data for sorting
const transformDataForSorting = (data) => {
  return data.map((item) => ({
    ...item,
    companyName: item.company.name,
    contactEmail: item.contact.email,
  }));
};

export const DistributorsTable = ({ pendingDistributors = [] }) => {
  const navigate = useNavigate();
  const transformedData = transformDataForSorting(mockDistributorsData);
  
  const { sortedData, sortConfig, handleSort } = useTableSort(transformedData, {
    initialField: null,
    initialDirection: null,
  });

  const handleHeaderSort = (field) => {
    handleSort(field);
  };

  const handleRowClick = (distributorId) => {
    navigate(ROUTE_PATHS.subscriptionPortalPages.distributorDetailsPages.overview(distributorId));
  };

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <DistributorsTableHeader
          columns={headerColumns}
          sortConfig={sortConfig}
          onSort={handleHeaderSort}
        />
        <tbody>
          {pendingDistributors.map((pending) => (
            <PendingDistributorRow
              key={pending.id}
              data={pending}
            />
          ))}
          {sortedData.map((row, index) => (
            <DistributorsTableRow
              key={row.id}
              data={row}
              isAlternate={index % 2 === 1}
              onRowClick={handleRowClick}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
